// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2jhJW","insightsList":"newBusinessInsightsMenu_insightsList__2YTBD","active":"newBusinessInsightsMenu_active__1hEet"};